export default __webpack_public_path__ + "static/media/whatapps.806297ec.png";